import { classNames } from '@repo/ui/src/utils/classNames';

interface FormHelpTextProps {
  display: boolean;
  content: string;
  unique: string;
}

const FormHelpText = ({ display, content, unique }: FormHelpTextProps) => {
  return (
    <div className={classNames('p-6', display ? 'block' : 'hidden')} id={`${unique}-help`}>
      {content && Array.isArray(content.split('\n')) ? (
        content.split('\n').map((cont, idx) => (
          <p
            id={`${unique}-help-${idx}`}
            key={`${unique}-help-${idx}`}
            className="m-0 tra-text-web-body-s"
          >
            {cont}
          </p>
        ))
      ) : typeof content === 'string' ? (
        <p
          id={`${unique}-help-text`}
          key={`${unique}-help-text`}
          className="tra-text-web-body-s mt-6"
        >
          {content}
        </p>
      ) : null}
    </div>
  );
};

export default FormHelpText;
